module.exports = __webpack_public_path__ + "static/media/pillars-right.d209f399.webp";